import { getTimeStamp } from '../utilis/getTimeStamp';
import { userComApiSendProductEvent } from '../api';
import { getDayDiscount } from '../utilis/getDayDiscount';
import { getDietDailyCostAfterDaysDiscountPerSetDay } from '../utilis/getDietDailyCostPerSetDay';
import { createSideOrdersArray } from '../utilis/createSideOrdersArray';
import { sideOrdersPriceCount } from '../utilis/sideOrdersPriceCount';

export const userComAddProductEvent = (
  orderForm,
  selectedCity,
  userCom,
  chooseSideOrders
) => {
  const {
    days,
    mealExchange,
    selectedCalories: { calories },
    selectedDiet: { dietId, dietName, discounts },
    selectedDietCaloriesIdPrices,
    selectedOption: { dietOptionName },
  } = orderForm;

  const { name, sectorId } = selectedCity;

  const dayDiscount = getDayDiscount(discounts, days);

  const dietCostPerSetDay = selectedDietCaloriesIdPrices.find(
    price => price.sectorId === sectorId
  ).price;

  const dietCostAfterDaysDiscountPerSetDay =
    getDietDailyCostAfterDaysDiscountPerSetDay(dietCostPerSetDay, dayDiscount);

  const priceOfSideOrders = chooseSideOrders?.priceOfSideOrders;
  const priceOfSideOrdersMenuConf = mealExchange.totalPrice?.sideOrdersPriceSum;

  const data = {
    data: {
      address_city: name,
      // address_street: street - nie ma dostępu w formularzu na tym etapie
      calories: calories,
      diet_name: dietName,
      product_id: dietId,
      product_name: dietName,
      side_orders: createSideOrdersArray(mealExchange.days) || [],
      URL: window.location.origin,
      value:
        dietCostPerSetDay * days +
        sideOrdersPriceCount(priceOfSideOrders, priceOfSideOrdersMenuConf),
      valueAfterDaysDiscount:
        dietCostAfterDaysDiscountPerSetDay * days +
        sideOrdersPriceCount(priceOfSideOrders, priceOfSideOrdersMenuConf),
      variant: dietOptionName,
    },
    event_type: 'add to cart',
    timestamp: getTimeStamp(),
    client: userCom.userId,
  };
  userComApiSendProductEvent(dietId, data, userCom).catch(e => console.log(e));
};
